<template>
    <u-textarea-outlined-rounded v-model="modelValue" v-bind="$attrs" class="v-text-field--label-inner" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-textarea-outlined-rounded>
</template>

<script>
import UTextareaOutlinedRounded from "@/components/publish/styles/forms/u-textarea-outlined-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextareaOutlinedRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
